import { render, staticRenderFns } from "./VehicleStates.vue?vue&type=template&id=0b8c1a7d"
import script from "./VehicleStates.vue?vue&type=script&lang=ts"
export * from "./VehicleStates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports